<form [formGroup]="form">
  <ifc-base-filter-dialog [form]="form" (confirmed)="onConfirmed($event)">
    <mat-form-field appearance="outline" baseFilterItem>
      <mat-label>First Name</mat-label>
      <input matInput formControlName="firstName" type="text" placeholder="First Name" />
      <button
        type="button"
        *ngIf="form.controls.firstName.value"
        matSuffix
        mat-icon-button
        aria-label="Clear"
        (click)="form.controls.firstName.setValue('')"
      >
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>

    <mat-form-field appearance="outline" baseFilterItem>
      <mat-label>Last Name</mat-label>
      <input matInput formControlName="lastName" type="text" placeholder="Last Name" />
      <button
        type="button"
        *ngIf="form.controls.lastName.value"
        matSuffix
        mat-icon-button
        aria-label="Clear"
        (click)="form.controls.lastName.setValue('')"
      >
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>

    <ifb-customer-email-input [fc]="form.get('email')" baseFilterItem></ifb-customer-email-input>
    <ifb-customer-ssn-input [fc]="form.get('ssn')" baseFilterItem></ifb-customer-ssn-input>

    <ifb-business-name-input [fc]="form.get('businessName')" baseFilterItem></ifb-business-name-input>
    <ifc-account-loan-number-input [fc]="form.get('loanNumber')" baseFilterItem></ifc-account-loan-number-input>

    <mat-form-field appearance="outline" baseFilterItem>
      <mat-label>Status</mat-label>
      <mat-select matInput formControlName="active" placeholder="Status">
        <mat-option>All</mat-option>
        <mat-option value="true">Active</mat-option>
        <mat-option value="false">Inactive</mat-option>
      </mat-select>
    </mat-form-field>
  </ifc-base-filter-dialog>
</form>
